import styled from "styled-components";

export const AuthenLayoutStyled = styled.div`
  .desktop_authen_layout {
    padding: 24px;
    background: ${({ theme }) => theme.COLORS.GRAY_13};
    .body_container_authen_layout {
      border-radius: 12px;
      min-height: calc(100vh - 48px);
      display: flex;
      justify-content: center;
      background: ${({ theme }) => theme.COLORS.WHITE_1};
      .content_authen_layout {
        padding-top: 6%;
        padding-bottom: 6%;
        width: 100%;
        max-width: 420px;
        .lagnuage_wrap {
          margin-bottom: 40px;
        }
        .logo_authen_layout {
          margin: auto;
          margin-bottom: 40px;
          width: 211px;
          height: auto;
        }
      }
    }
  }
  .authen_mobile_layout {
    padding: 16px;
    .lagnuage_mobile_wrap {
      margin-bottom: 60px;
    }
    .body_mobile_container_authen_layout {
      .logo_mobile_authen_layout {
        margin: auto;
        margin-bottom: 40px;
        width: 165px;
        height: auto;
      }
    }
  }
`;
